<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.channel_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="createChannel()"
    sbTooltip="{{ 'lang.channels.createChannel' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

     Table Wrapper

------------------------------->
@let isExpanded = checkExpansion();
@let ordering = orderOption();
<sb-table-wrapper-new
  headline="{{'lang.headlines.channels' | translate}}"
  [itemsData]="channels"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'channels'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section
        title="{{'lang.globals.filterAttributes' |translate}}" icon="wrench"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-threeway-toggle filterID="hasDevices" [default]="null"
                                   [label]="'lang.attributeToggles.channel.hasDevices' | translate"></sb-filter-threeway-toggle>
      </sb-filter-section>

      <sb-filter-section *ngPermissions="permissionService.Permission.channel_show" title="{{'lang.globals.resolution' | translate}}"
                         icon="resolution">
        <sb-filter-dto-list-select filterID="resolution" [isSingleSelect]="true"
                                   [endpoint]="api.mm_Medium_retrieveAllResolutions.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>


      <ng-template #orderSection>
        <sb-filter-section
          [alwaysExpanded]="true" [hideValueIndicatorIfDefaultSelected]="true" [showTag]="false"
          title="{{'lang.globals.order' | translate}}" icon="sort">
          <sb-filter-order
            [allOrderOptions]="allOrderOptions|omit: 'direction'"
            [selectedOrderOption]="orderOption()"
          >
          </sb-filter-order>
        </sb-filter-section>
      </ng-template>
    </sb-filter-panel>
  </div>
  <!------------------------------

       Table Header

 ------------------------------->
  <ng-template #thead>
    <tr>
      <th class="table--sortable" (click)="setToOrderAndRefresh(ss_nm_Channel_retrieveAll_order.NAME)"
          [ngClass]="{'table--sorted': ordering?.value===ss_nm_Channel_retrieveAll_order.NAME}">
        {{ 'lang.globals.name' | translate }}
        @if (ordering.value === ss_nm_Channel_retrieveAll_order.NAME) {
          @if (ordering.direction === 'desc') {
            <sb-icon
              icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon
              icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>{{ 'lang.channels.description' | translate }}</th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(ss_nm_Channel_retrieveAll_order.COUNT_DEVICES)"
          [ngClass]="{'table--sorted': ordering?.value===ss_nm_Channel_retrieveAll_order.COUNT_DEVICES}">
        {{ 'lang.globals.devices' | translate }}
        @if (ordering.value === ss_nm_Channel_retrieveAll_order.COUNT_DEVICES) {
          @if (ordering.direction === 'desc') {
            <sb-icon
              icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon
              icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(ss_nm_Channel_retrieveAll_order.COUNT_DEVICES_PRODUCTIVE)"
          [ngClass]="{'table--sorted': ordering?.value===ss_nm_Channel_retrieveAll_order.COUNT_DEVICES_PRODUCTIVE}">
        {{ 'lang.globals.devicesProductive' | translate }}
        @if (ordering.value === ss_nm_Channel_retrieveAll_order.COUNT_DEVICES_PRODUCTIVE) {
          @if (ordering.direction === 'desc') {
            <sb-icon
              icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon
              icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th>{{ 'lang.channels.adspaces' | translate }}</th>
      <th class="table--sortable" (click)="setToOrderAndRefresh(ss_nm_Channel_retrieveAll_order.CREATED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===ss_nm_Channel_retrieveAll_order.CREATED_AT}">
        {{ 'lang.globals.created' | translate }}
        @if (ordering.value === ss_nm_Channel_retrieveAll_order.CREATED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon
              icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon
              icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-data>
    @let channel = identity(data);
    <tr>
      <td>
        <sb-comp-image-name-wrapper [image]='channel?.logo?.url' [thumbnailSize]="ThumbnailSize.S">
          <sb-comp-link
            [condition]="permissionService.hasPermissions([permissionService.Permission.channel_show, permissionService.Permission.channel_list])"
            [link]="util.RoutingID.channelDetails"
            [pathParams]="[{id: 'channelID', value: channel?.id}]"
            [title]="channel?.name" [tooltip]="'lang.globals.openDetails' | translate"
            firstLine>
          </sb-comp-link>
          <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="channel.id"
                   [dtoType]="tagService.TaggableDTO.Channel"
                   [tags]="channel.tags" secondLine></sb-tags>
        </sb-comp-image-name-wrapper>
      </td>
      <td>{{ channel?.description }}</td>
      <td>{{ channel?.countDevices }}</td>
      <td>{{ channel?.countDevicesProductive }}</td>
      <td>
        @for (marker of channel?.markers; track marker.name) {
          <div>
            <span>{{ marker.name }} ({{ marker?.resolution?.id }})</span>
          </div>
        }
      </td>
      <td>
        <sb-comp-display-created [data]="channel"></sb-comp-display-created>
      </td>

      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="channel.sbButtons ?? []"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
